import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Scope } from '@garmin-avcloud/avcloud-fly-web-common/admin-authorization';
import { FeatureFlyAdmin } from '@garmin-avcloud/avcloud-fly-web-common/shared';
import { featureGuard } from '@garmin-avcloud/avcloud-web-utils';
import { AuthLayoutComponent } from '../components/layouts/auth-layout/auth-layout.component';
import { FullLayoutComponent } from '../components/layouts/full-layout/full-layout.component';
import { scopeGuard } from '../core/guards/scope.guard';
import { AircraftLibraryWriteGuard } from '../features/aircraft-library/guards/aircraft-library-write.guard';
import { authGuard } from '../features/auth/guards/auth.guard';
import { DownForMaintenanceComponent } from '../shared/components/pages/down-for-maintenance/down-for-maintenance.component';

const routes: Routes = [
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      {
        loadChildren: () => import('../features/auth/routing/auth.routes').then((r) => r.FLYADMIN_AUTH_ROUTES),
        path: ''
      }
    ]
  },
  {
    path: '',
    component: FullLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        loadChildren: () => import('../features/aircraft/modules/aircraft.module').then((m) => m.AircraftModule),
        path: 'aircraft'
      },
      {
        loadChildren: () =>
          import('../features/aircraft-library/modules/aircraft-library.module').then((m) => m.AircraftLibraryModule),
        path: 'aircraft-library',
        canActivateChild: [AircraftLibraryWriteGuard]
      },
      {
        loadChildren: () => import('../features/aircraft-logbook/logbook.routes'),
        path: 'aircraft-logbook',
        canActivate: [scopeGuard],
        data: {
          scopes: [Scope.AIRCRAFT_LOGBOOK_ADMIN_READ]
        }
      },
      {
        loadChildren: () => import('../features/devices/modules/devices.module').then((m) => m.DevicesModule),
        path: 'devices'
      },
      {
        loadChildren: () => import('../features/products/products.routes').then((r) => r.PRODUCTS_ROUTES),
        path: 'products',
        canActivate: [scopeGuard],
        data: {
          scopes: [Scope.AVDB_SUBSCRIPTION_GRANT, Scope.AVDB_SUBSCRIPTION_UPDATE]
        }
      },
      {
        loadChildren: () => import('../features/users/modules/users.module').then((m) => m.UsersModule),
        path: 'users'
      },
      {
        loadChildren: () => import('../features/orgs-roles/orgs-roles-routes').then((m) => m.generateOrgRoutes()),
        path: 'orgs'
      },
      {
        loadChildren: () => import('../features/jeppesen/routing/jeppesen.routes').then((r) => r.JEPPESEN_ROUTES),
        path: 'jeppesen'
      },
      {
        loadChildren: () => import('../features/portables/portables.routes').then((r) => r.PORTABLES_ROUTES),
        path: 'portables',
        canActivate: [featureGuard],
        data: {
          feature: FeatureFlyAdmin.ENABLE_NEW_ADD_PORTABLE
        }
      },
      {
        path: 'tools',
        loadChildren: () => import('../features/tools/tools.routes'),
        canActivate: [featureGuard],
        data: {
          feature: FeatureFlyAdmin.CERTIFIED_SOFTWARE
        }
      },
      {
        loadChildren: () => import('../features/not-found/modules/not-found.module').then((m) => m.NotFoundModule),
        path: 'not-found'
      },
      {
        path: 'training',
        loadChildren: () => import('../features/training/training.routes')
      },
      {
        path: 'maintenance',
        component: DownForMaintenanceComponent
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'aircraft'
      },
      {
        path: '**',
        redirectTo: 'not-found'
      }
    ]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })]
})
export class AppRoutingModule {}
